<template>
  <div>
    <div class="over-lay" @click="closePopup"></div>
    <div class="popup">
      <div class="hdr">Find domain?</div>
      <div class="txt-desc" v-html="text"></div>
      <form
        v-on:submit.prevent="updateDomain"
        class="form-section"
        ref="formDomain"
      >
        <!-- <Input-Floating-Label
          ref="companyName"
          :autocomplete="'off'"
          :type="'text'"
          :value="companyName"
          :required="'true'"
          :id="'companyName'"
          :placeholder="'Company Name'"
        /> -->
        <Input-Floating-Label
          ref="domain"
          :autocomplete="'off'"
          :type="'text'"
          :value="domain"
          :required="'true'"
          :id="'domain'"
          :pattern="'(.+[.?].+)'"
          :title="'Please enter valid domain'"
          :placeholder="'Company Domain'"
        />
        <div class="btn-section d-flex">
          <!-- <button @click="closePopup">Cancel</button> -->
          <V-Button
            :className="'cancelBtn'"
            :callback="closePopup"
            :text="'Cancel'"
            :type="'button'"
          ></V-Button>
          <input :class="'btn-blue'" :value="'View Email'" :type="'submit'" />
          <!-- <button type="submit" class="btn-blue">Update</button> -->
        </div>
      </form>
    </div>
  </div>
</template>

<script>
// import homeIcon from './../assets/icons/svg/home.svg'
import button from './../components/Button'
import InputFloatingLabel from './../components/InputFloatingLabel'
export default {
  name: 'Add-Domain-Find-Email',
  props: ['text', 'data'],
  data: function() {
    return {
      showPopup: false,
      domain: ''
      // companyName: ''
    }
  },
  components: {
    'V-Button': button,
    'Input-Floating-Label': InputFloatingLabel
  },
  methods: {
    closePopup() {
      this.$emit('clickedOutside', true)
    },
    updateDomain() {
      const dataMap = {
        domain: this.$refs.domain.$refs.input.value
      }
      this.closePopup()
      this.$parent.$emit('newDomainSubmitted', dataMap)
    }
  },
  mounted: function() {
    this.$refs.domain.$refs.input.focus()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.over-lay {
  background: rgb(0, 0, 0, 0.85);
  position: fixed;
  height: 100%;
  top: 0px;
  width: 100%;
  left: 0;
  z-index: 3;
}
.popup {
  position: fixed;
  width: 82%;
  color: #787878;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 20px;
  border-radius: 5px;
  background-color: $white;
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: center;
  .hdr {
    font-size: 22px;
    text-align: center;
    font-weight: 500;
    display: none;
  }
  .txt-desc::v-deep {
    width: 70%;
    text-align: center;
    line-height: 1.46;
    font-size: 15px;
    margin-top: 15px;
    margin-bottom: 10px;
    span {
      color: $primary-color;
    }
  }
  .form-section {
    width: 100%;
    .btn-section::v-deep {
      margin-top: 30px;
      overflow: hidden;
      button,
      input {
        width: 90px;
        padding: 10px 0px;
        margin: 0 5px;
        font-size: 14px;
        border: solid 1px #56a2f9;
        border-radius: 5px;
        background-color: $white;
      }
      input.btn-blue {
        background-color: $primary-color;
        color: $white;
      }
      .cancelBtn {
        color: $primary-color;
      }
    }
  }
}
</style>
